import React from 'react';
import { connect } from 'react-redux';

import { BrowserRouter as Router, Switch, Route, Link } from 'react-router-dom';

import { Container } from '@amzn/stencil-react-components/layout';

import LandingPage from '../components/LandingPage';
import OnboardGroup from '../components/OnboardGroup';
import SegmentContainer from './SegmentsContainer';
import CreateSegmentContainer from './CreateSegmentContainer';
import CreateContentContainer from './CreateContentContainer';
import { LogoutPage } from '../components/LogoutPage';

import { setLoggedOut } from '../actions/userInfoActions';
import {
  CAMPAIGN_LIST_PAGE,
  CREATE_CONTENT_PAGE,
  CREATE_SEGMENT_PAGE,
  HOME_PAGE,
  LOGOUT_PAGE,
  ONBOARD_PAGE,
  SCHEDULING_LANDING_PAGE,
  SEGMENT_PAGE,
  CREATE_JOURNEY_PAGE,
  PARENTEX_CAMPAIGN_PAGE,
} from '../constants/routesConstant';
import SchedulingContainer from './SchedulingContainer';
import { CampaignList } from './CampaignList';
import JourneyContainer from './JourneyContainer';
import ParentExCampaignContainer from './ParentExCampaignContainer';

class MainContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container
        backgroundColor="neutral0"
        flexDirection="column"
        flex={1}
        alignItems="stretch"
        justifyContent="stretch"
        isFullWidth={true}
      >
        <Switch flex="1">
          <Route
            path={CREATE_SEGMENT_PAGE}
            exact
            render={props => <CreateSegmentContainer {...props} />}
          />
          <Route path={ONBOARD_PAGE} render={props => <OnboardGroup {...props} />} />
          <Route path={SEGMENT_PAGE} render={props => <SegmentContainer {...props} />} />
          <Route path={CREATE_JOURNEY_PAGE} render={props => <JourneyContainer {...props} />} />
          <Route
            path={CREATE_CONTENT_PAGE}
            render={props => <CreateContentContainer {...props} />}
          />
          <Route
            path={SCHEDULING_LANDING_PAGE}
            render={props => <SchedulingContainer {...props} />}
          />
          <Route
            path={LOGOUT_PAGE}
            render={props => (
              <LogoutPage
                handlers={{
                  setLoggedOut: isLoggedOut => {
                    this.props.setLoggedOut(isLoggedOut);
                  },
                }}
                {...props}
              />
            )}
          />
          <Route path={CAMPAIGN_LIST_PAGE} render={props => <CampaignList {...props} />} />
          <Route path={PARENTEX_CAMPAIGN_PAGE} render={props => <ParentExCampaignContainer {...props} />} />
          <Route path={HOME_PAGE} render={props => <LandingPage {...props} />} />
        </Switch>
      </Container>
    ); 
  }
}

const mapStateToProps = state => ({
  nudge: { ...state.nudge },
});

const mapDispatchToProps = {
  setLoggedOut,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MainContainer);
